/**
 * custom-phaser-wishlist.js
 * Boots Mst Wishlist Prime (iWish) on Horizon: jQuery + binders + header count + /apps/iwish page polish.
 */
(function () {
  const JQUERY_SRC = 'https://code.jquery.com/jquery-3.7.1.min.js';
  const IWISH_SRC = 'https://cdn.myshopapps.com/iwish/iwishlist_v2.js';
  const HEADER_SELECTOR = '.phaser-wishlist-header';
  const COUNT_SELECTOR = '.phaser-wishlist-header .iWishCount';
  const PAGE_WRAPPER = '.iwishWrapper';
  const EMPTY_CLASS = 'phaser-wishlist-empty';

  let countObserver = null;
  let syncingCount = false;
  let pageObserver = null;

  /**
   * Go straight to the wishlist page on every viewport. The app's own click
   * handler slides its drawer open and the iWishPost navigation then lands on
   * the wishlist page anyway, so the drawer was a pointless flash of a loading
   * spinner before the page load — it never finished rendering anything useful.
   * Capture phase so this outruns the app's element-level handler.
   */
  function bindDirectNavigation() {
    document.addEventListener(
      'click',
      function (event) {
        if (!(event.target instanceof Element)) return;
        const link = event.target.closest("a.iWishView, a[href='/apps/iwish']");
        if (!link) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (typeof window.iWishPost === 'function') {
          window.iWishPost('/apps/iwish', {
            iwishlist: JSON.stringify(window.iWishlistmain || {}),
            cId: window.iwish_cid || '',
          });
        } else {
          window.location.assign('/apps/iwish');
        }
      },
      true
    );
  }

  bindDirectNavigation();

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      const existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === 'true') {
          resolve();
          return;
        }
        existing.addEventListener('load', function () {
          resolve();
        });
        existing.addEventListener('error', reject);
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      script.addEventListener('load', function () {
        script.dataset.loaded = 'true';
        resolve();
      });
      script.addEventListener('error', reject);
      document.head.appendChild(script);
    });
  }

  function parseCount(value) {
    if (typeof value === 'number' && Number.isFinite(value)) {
      return Math.max(0, Math.floor(value));
    }
    if (typeof value === 'string' && value.trim() !== '' && !Number.isNaN(Number(value))) {
      return Math.max(0, Math.floor(Number(value)));
    }
    return null;
  }

  function readStoredCount() {
    try {
      if (typeof Storage === 'undefined') return null;
      return parseCount(localStorage.getItem('iWishCnt'));
    } catch (error) {
      return null;
    }
  }

  function readBadgeCount() {
    const badge = document.querySelector(COUNT_SELECTOR);
    if (!badge) return null;
    return parseCount(badge.getAttribute('data-count')) ?? parseCount(badge.textContent);
  }

  function resolveWishlistCount() {
    return parseCount(window.iWishCnt) ?? readStoredCount() ?? readBadgeCount() ?? 0;
  }

  function syncHeaderCount() {
    const count = resolveWishlistCount();
    const label = String(count);

    syncingCount = true;
    if (countObserver) countObserver.disconnect();

    document.querySelectorAll(HEADER_SELECTOR).forEach(function (el) {
      el.classList.toggle('is-empty', count < 1);
      el.setAttribute('data-wishlist-count', label);

      const badge = el.querySelector('.iWishCount');
      if (!badge) return;

      badge.setAttribute('data-count', label);
      if (badge.textContent !== label) {
        badge.textContent = label;
      }
    });

    if (typeof window.iWishCnt === 'number' && window.iWishCnt !== count) {
      window.iWishCnt = count;
    }

    syncingCount = false;
    observeCountBadge();
  }

  function refreshProductState() {
    if (typeof window.jQuery === 'undefined' || typeof window.checkIwish !== 'function') return;
    if (!window.iwish_pro_template) return;

    const $ = window.jQuery;
    const wrap = $('.iWishAdd:visible').parents(window.iwishWrapperClass);
    if (!wrap.length) return;
    const variantId = wrap.find(window.iWishVarSelector).val();
    if (variantId) window.checkIwish(wrap, variantId);
  }

  /* Wishlist-link navigation is handled by bindDirectNavigation() above, which
     runs in capture phase and calls stopImmediatePropagation — a delegated
     handler on document could never fire. Only the add binder lives here. */
  function bindClicks() {
    const $ = window.jQuery;

    $(document)
      .off('click.phaserWishlist', '.iWishAdd')
      .on('click.phaserWishlist', '.iWishAdd', function (event) {
        event.preventDefault();
        const $btn = $(this);
        const wrap = $btn.parents(window.iwishWrapperClass);
        const variantId = wrap.find(window.iWishVarSelector).val();
        if (typeof window.iwish_add === 'function') {
          window.iwish_add($btn, variantId);
        }
        window.setTimeout(syncHeaderCount, 50);
        window.setTimeout(syncHeaderCount, 300);
        return false;
      });
  }

  function bindHorizonVariants() {
    document.addEventListener('variant:selected', function () {
      window.setTimeout(function () {
        refreshProductState();
        syncHeaderCount();
      }, 50);
    });
    document.addEventListener('variant:update', function () {
      window.setTimeout(function () {
        refreshProductState();
        syncHeaderCount();
      }, 50);
    });
  }

  function observeCountBadge() {
    const badges = document.querySelectorAll(COUNT_SELECTOR);
    if (!badges.length || typeof MutationObserver === 'undefined') return;

    if (!countObserver) {
      countObserver = new MutationObserver(function () {
        if (syncingCount) return;
        syncHeaderCount();
      });
    }

    badges.forEach(function (badge) {
      countObserver.observe(badge, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-count'],
      });
    });
  }

  function scheduleCountResync() {
    [100, 400, 1200].forEach(function (delay) {
      window.setTimeout(syncHeaderCount, delay);
    });
  }

  function pageCopy() {
    const cfg = window.phaserWishlistPage || {};
    return {
      emptyTitle: cfg.emptyTitle || 'Wishlist is empty.',
      emptyBody: cfg.emptyBody || "You haven't saved any products yet.",
      continueShopping: cfg.continueShopping || 'Continue shopping',
      shopUrl: cfg.shopUrl || '/collections/all',
    };
  }

  function isWishlistPage() {
    return Boolean(document.querySelector(PAGE_WRAPPER));
  }

  function wishlistHasItems() {
    return document.querySelectorAll('.iwishProducts .iwishItem').length > 0;
  }

  function removeEmptyState() {
    document.querySelectorAll('.' + EMPTY_CLASS).forEach(function (el) {
      el.remove();
    });
    const wrapper = document.querySelector(PAGE_WRAPPER);
    if (wrapper) wrapper.classList.remove('is-empty-page');
  }

  function renderEmptyState() {
    const wrapper = document.querySelector(PAGE_WRAPPER);
    const products = document.querySelector('.iwishProducts');
    if (!wrapper || !products) return;

    removeEmptyState();
    if (wishlistHasItems()) return;

    wrapper.classList.add('is-empty-page');
    const copy = pageCopy();
    const empty = document.createElement('div');
    empty.className = EMPTY_CLASS;
    empty.setAttribute('role', 'status');
    empty.innerHTML =
      '<div class="' +
      EMPTY_CLASS +
      '__icon" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" focusable="false">' +
      '<path d="M12.1 21.35 10.55 19.9C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.4l-1.35 1.45Z"/>' +
      '</svg></div>' +
      '<h2 class="' +
      EMPTY_CLASS +
      '__title">' +
      copy.emptyTitle +
      '</h2>' +
      '<p class="' +
      EMPTY_CLASS +
      '__body">' +
      copy.emptyBody +
      '</p>' +
      '<a class="button ' +
      EMPTY_CLASS +
      '__cta" href="' +
      copy.shopUrl +
      '"><span class="button-text">' +
      copy.continueShopping +
      '</span></a>';

    products.insertAdjacentElement('afterend', empty);

    // Hide raw app empty flash once our empty state is shown
    const info = document.querySelector('.sysMessage .iwishMsgInfo');
    if (info) info.setAttribute('hidden', '');
  }

  function enhanceWishlistPage() {
    if (!isWishlistPage()) return;

    document.documentElement.classList.add('phaser-wishlist-page');
    renderEmptyState();
    syncHeaderCount();

    if (typeof MutationObserver === 'undefined') return;
    const products = document.querySelector('.iwishProducts');
    if (!products) return;

    if (pageObserver) pageObserver.disconnect();
    pageObserver = new MutationObserver(function () {
      if (wishlistHasItems()) {
        removeEmptyState();
        const info = document.querySelector('.sysMessage .iwishMsgInfo');
        if (info) info.removeAttribute('hidden');
      } else {
        renderEmptyState();
      }
      syncHeaderCount();
    });
    pageObserver.observe(products, { childList: true, subtree: true });
  }

  function bindWishlistPageHook() {
    const previous = typeof window.iWishPageinitFn === 'function' ? window.iWishPageinitFn : null;
    window.iWishPageinitFn = function () {
      if (previous) previous();
      enhanceWishlistPage();
    };

    // Proxy may already have run, or page may load without items
    if (isWishlistPage()) {
      enhanceWishlistPage();
      [200, 600, 1500].forEach(function (delay) {
        window.setTimeout(enhanceWishlistPage, delay);
      });
    }
  }

  async function boot() {
    try {
      if (typeof window.jQuery === 'undefined') {
        await loadScript(JQUERY_SRC);
      }
      await loadScript(IWISH_SRC);
      bindClicks();
      bindHorizonVariants();
      observeCountBadge();
      syncHeaderCount();
      scheduleCountResync();
      refreshProductState();
      bindWishlistPageHook();
    } catch (error) {
      console.warn('[phaser-wishlist] failed to boot Wishlist Prime', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
